import { Column, Row, Typography } from '@viewup/ui';
import { APP_STORE_URL, PLAY_STORE_URL } from 'app/invite/invite.const';
import Image from 'next/image';
import { QRCodeSVG } from 'qrcode.react';
import type { ReactNode } from 'react';

export interface AppOnlyGuideContentProps {
  /** 제목 — 줄바꿈이 필요하면 호출부에서 `\n` 과 `whiteSpace: pre-line` 이 먹도록 문자열로 넘긴다 */
  title: ReactNode;
}

const STORE_LINKS = [
  { label: '구글 앱스토어', url: PLAY_STORE_URL },
  { label: 'IOS 앱스토어', url: APP_STORE_URL },
] as const;

/**
 * 앱 전용 기능 안내 본문(제목·서브카피·스토어 QR/바로가기·워드마크).
 * context-free — 모달/페이지 어느 쪽 컨테이너에서도 흐름 배치로 렌더된다.
 */
export const AppOnlyGuideContent = (props: AppOnlyGuideContentProps) => {
  const { title } = props;

  return (
    <Column alignItems='center'>
      <Column alignItems='center' gap={8}>
        <Typography
          color='text.primary'
          css={{ textAlign: 'center', whiteSpace: 'pre-line' }}
          fontType='title3.bold'
        >
          {title}
        </Typography>
        <Typography color='text.secondary' fontType='body.regular'>
          더 새로워진 뷰업을 만나보세요.
        </Typography>
      </Column>

      <Row css={{ marginTop: 20 }} gap={40} justifyContent='center'>
        {STORE_LINKS.map((store) => (
          <Column alignItems='flex-start' css={{ gap: 6 }} key={store.label} width={104}>
            <QRCodeSVG size={96} value={store.url} />
            <a
              href={store.url}
              rel='noopener noreferrer'
              style={{ textDecoration: 'none' }}
              target='_blank'
            >
              <Typography
                color='text.secondary'
                css={{ whiteSpace: 'pre-line' }}
                fontType='body.bold'
              >
                {`${store.label}\n바로가기 ↗`}
              </Typography>
            </a>
          </Column>
        ))}
      </Row>

      <Image
        alt='VIEWUP'
        height={16}
        src='/Logo/ViewupWordmark.svg'
        style={{ marginTop: 46 }}
        width={88}
      />
    </Column>
  );
};
